/**
 * Created by Administrador on 24/04/2017.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {
        $stateProvider
            .state('dosages', {
                parent: 'app',
                url: '/dosage?page&size',
                params: {
                    page: "0",
                    size: "10"
                },
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/finance/dosage/dosages.html',
                        controller: 'dosageCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['dosage']);
                            }],
                            dosages: ['dosageService','$stateParams', function(dosageService,$stateParams){
                                return dosageService.getPageDosages($stateParams.page, $stateParams.size,true);
                            }]
                        }
                    }
                }
            })
            .state('dosageNew', {
                parent: 'app',
                url: '/dosage/new',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/finance/dosage/newDosage.html',
                        controller: 'newDosageCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['dosage']);
                            }],
                            taxpayers: ['taxpayerService', function(taxpayerService){
                                return taxpayerService.getTaxpayers();
                            }],
                            billingModes: ['billingModeService', function(billingModeService){
                                return billingModeService.getBillingModes();
                            }]
                        }
                    }
                }
            })
            .state('dosageEdit', {
                parent: 'app',
                url: '/dosage/:id/edit',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/finance/dosage/editDosage.html',
                        controller: 'editDosageCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['dosage']);
                            }],
                            dosage: ['dosageService','$stateParams', function(dosageService,$stateParams){
                                return dosageService.getDosage($stateParams.id);
                            }],
                            taxpayers: ['taxpayerService', function(taxpayerService){
                                return taxpayerService.getTaxpayers();
                            }],
                            billingModes: ['billingModeService', function(billingModeService){
                                return billingModeService.getBillingModes();
                            }],
                            isDisabled: [function(){
                                return false;
                            }]
                        }
                    }
                }
            })
            .state('dosageView', {
                parent: 'app',
                url: '/dosage/:id/view',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/finance/dosage/viewDosage.html',
                        controller: 'editDosageCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['dosage']);
                            }],
                            dosage: ['dosageService','$stateParams', function(dosageService,$stateParams){
                                return dosageService.getDosage($stateParams.id);
                            }],
                            taxpayers: ['taxpayerService', function(taxpayerService){
                                return taxpayerService.getTaxpayers();
                            }],
                            billingModes: ['billingModeService', function(billingModeService){
                                return billingModeService.getBillingModes();
                            }],
                            isDisabled: [function(){
                                return true;
                            }]
                        }
                    }
                }
            })
            .state('dosageDelete', {
                parent: 'dosages',
                url: '/dosage/:id/delete',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/finance/dosage/deleteDosage.html',
                        controller: 'deleteDosageController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['dosage']);
                            }]
                        }
                    }).result.then(function() {
                        $state.go('dosages', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    });
                }]
            });
    }
})();
